import {register} from '../vendor/theme-scripts/theme-sections';
import {quickviewSection} from '../features/quickview';

register('search', [quickviewSection]);
